import { create } from 'zustand';

export const useAdvancedEditorStore = create((set) => ({
  isOpen: false,
  clientUuid: null,
  isLastPhoto: null,
  openEditor: ({ clientUuid, isLastPhoto }) => {
    set({
      isOpen: true,
      clientUuid,
      isLastPhoto,
    });
  },
  closeEditor: () =>
    set({
      isOpen: false,
      clientUuid: null,
      isLastPhoto: null,
    }),
}));
